import React from 'react';
import './AddressBox.scss';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { TranslationUtils } from '../../utils';

interface AddressBoxProps {
    compact?: boolean;
}

export const AddressBox: React.FC<AddressBoxProps> = ({ compact = true }) => {
    const unit = useSelector((store: { trip: TripState }) => store.trip.unit);

    if (!unit) {
        return null;
    }

    const { address_1, address_2, city, state, country_code, latitude, longitude } = unit;

    const addressHtml = `${address_1}<br/>${address_2 ? address_2 + '<br/>' : ''}${city}, ${state}, ${country_code}`;
    const ariaLabel = `${address_1}, ${city}, ${country_code} ${TranslationUtils.get('address')}`;
    const mapsHref = `http://maps.google.com/maps?q=${latitude},${longitude}`;

    if (compact) {
        return (
            <div className="address-box">
                <p aria-hidden className="body-small-bold address-title">
                    {TranslationUtils.get('address')}
                </p>
                <a
                    role="link"
                    aria-label={ariaLabel}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="body-small address-link"
                    href={mapsHref}
                    dangerouslySetInnerHTML={{ __html: addressHtml }}
                />
            </div>
        );
    }

    return (
        <div className="address-box address-box--expanded">
            <a
                role="link"
                aria-label={ariaLabel}
                target="_blank"
                rel="noopener noreferrer"
                className="heading-small-light address-link address-link--expanded"
                href={mapsHref}
                dangerouslySetInnerHTML={{ __html: addressHtml }}
            />
            <p aria-hidden className="body-xs-bold address-subtitle">
                {TranslationUtils.get('address')}
            </p>
        </div>
    );
};
